import PageLayout from "@/components/PageLayout";
import { Link } from "react-router-dom";
import { Crown, Scroll, ArrowRight } from "lucide-react";

const SECTIONS = [
  { t: "1. Respect & Sisterhood", b: "Every Queen is expected to treat mentors, volunteers, and fellow queenz with kindness and respect. No bullying, gossip, name-calling, or exclusion. We rise by lifting others." },
  { t: "2. Attendance & Punctuality", b: "Consistent attendance is a sign of commitment. Parents must notify us of absences in advance whenever possible. Three unexcused absences may forfeit your seat to a queen on the waiting list." },
  { t: "3. Dress Code", b: "Comfortable, modest, age-appropriate attire. Avoid clothing with offensive language or imagery. Special-event dress codes will be communicated in advance." },
  { t: "4. Phones & Devices", b: "Phones stay on silent and away during sessions. Photo/video sharing of other queenz is not permitted without parental consent and Queenz Like Me approval." },
  { t: "5. Confidentiality", b: "What’s shared in the circle stays in the circle. Mentors are mandated reporters and are legally required to act on disclosures of harm — otherwise, every queen’s story is honored and protected." },
  { t: "6. Health & Safety", b: "Parents must disclose allergies, medical conditions, and emergency contacts on the registration form. A light snack is provided at every scheduled session. Queenz Like Me reserves the right to dismiss participants whose behavior endangers themselves or others." },
  { t: "7. Parent / Guardian Participation", b: "Parents are partners in this journey. We expect open communication, timely pickup, and support of program values at home." },
  { t: "8. Media Release", b: "Photos and short videos may be used for promotional and ministry purposes. Parents may opt out in writing at registration; we will honor it without question." },
  { t: "9. Financial Commitment", b: "Most programming is free thanks to sponsors. When dues, retreat fees, or supply fees apply, payment plans are available — talk to us, never let cost be a barrier." },
  { t: "10. Code of Conduct", b: "Queenz commit to honesty, integrity, and the Queenz Like Me values of Character, Courage, and Compassion. Violations are addressed privately and restoratively with parents." },
];

export default function RulesPage() {
  return (
    <PageLayout
      testid="rules-page"
      kicker="The Royal Code"
      title="Rules & Regulations"
      shareMessage="Read the Queenz Like Me Rules & Regulations — the values and guidelines that keep every queen safe and supported."
    >
      <section className="max-w-3xl mx-auto px-6 pb-16">
        <p className="mt-2 text-center text-[#5c4a54] leading-relaxed">
          Please read carefully — these guidelines keep every Queen safe,
          supported, and celebrated.
        </p>

        <div className="mt-10 space-y-6 text-[#1a0f14] leading-relaxed">
          {SECTIONS.map((s) => (
            <article
              key={s.t}
              className="rounded-2xl bg-white p-6 shadow-md border border-[#f0e1e8]"
            >
              <h2 className="font-display text-lg font-bold text-[#7d289b]">{s.t}</h2>
              <p className="mt-2 text-sm">{s.b}</p>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-3xl border-2 border-[#d4af37] bg-[#fff8e1] p-6 text-center">
          <Crown className="h-7 w-7 mx-auto text-[#d4af37]" />
          <p className="mt-2 font-display text-lg font-bold text-[#4a1466]">
            By participating, you and your queen agree to honor these rules.
          </p>
          <p className="mt-2 text-sm text-[#5c4a54]">
            The full participation agreement (with signature line) lives on its
            own page.
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-3">
            <Link
              to="/agreement"
              data-testid="rules-page-agreement-link"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#7d289b] text-white font-semibold text-sm hover:bg-[#4a1466] transition-colors"
            >
              <Scroll className="h-4 w-4" />
              Read &amp; sign the Participation Agreement
            </Link>
            <Link
              to="/register"
              data-testid="rules-page-register-link"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border-2 border-[#7d289b] text-[#7d289b] font-semibold text-sm hover:bg-[#7d289b] hover:text-white transition-colors"
            >
              I’m ready to register
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
